export const name = "Healing Edition"
export const menu = "Healing"
export const edition = "Healing Edition"
export const suggestedPlayer = "1+ players"
export const color = {
  primary: {
    main:  '#c10016',
    contrastText: '#ffffff',
  },
  secondary: {
      main:  '#c10016',
  }
}
export const levels = ['Healing Edition']
export const isExpansion = false

export const backDesc = [ 
  "Make your mind\n a good place to be"
]

export const instruction = [
  "If you're not speaking your truth, you're storing it. And that gets heavy. This pack is an invitation to get it all off your chest. Use it to self reflect, or play with someone who's ready to dig deep with you.",
  "Being honest about how you're really feeling is one of the most healing things you can do for youself and the people in your life.",
  "Ready?",
]

export const level1 = [
  "What or who do you need to set a healthy boundary with? Explain.",
  "What's been the best thing for your mental health lately? Get specific.",
  "What's been the worst thing for your mental health lately (that's within your control to change)?",
  "What does self-care look like for you? Get specific. Create that day for yourself this week.",
  "When was the last time you healed from something you weren't sure you could move past?",
  "Finish the sentence: I'm\n working on accepting _________.",
  "When was the last time you didn't ask for help, but really needed it? Explain.",
  "Finish the sentence: I need help with _________.",
  "I know my anxiety is setting in when _________. Get specific.",
  "Today I'm struggling with _________.",
  "Who's been good for your mental health? Send them a picture of this card as a thank you.",
  "What title would you give this chapter of your healing journey?",
  "How has your mental health affected your romantic relationships, if at all?",
  "Finish the sentence:\n I want to give myself permission to feel _________. What's getting in the way of that?",
  "How can you contribute to someone else's happiness today? Do that thing, big or small.",
  "What's been draining your energy lately? What's been giving you energy? Get specific.",
  "How have you neglected\n your mental health recently?\n What's one small way you can\n make it up to yourself?",
  "When was the first mental health scare you remember having? What stands out to you about it?",
  "What small step can you take\n towards your healing today?",
  "What are you currently healing from that others don't see?",
  "What emotion keeps coming up for you lately? Why do you think that is?",
  "What is your body telling you today?",
  "What's one thing (big or small) you're most looking forward to? What about it excites you most?",
  "What do you understand now about the healing process that you didn't before?",
  "What's been causing you unnecessary stress? What would help alleviate that for you?",
  "What hurt your younger self that you never fully healed from? What would you say to your younger self today?",
  "What have you been avoiding that deserves your attention? Why have you been avoiding it?",
  "What's a boundary you can set with yourself today that will benefit future you?",
  "What's something you can say \"no\" to this week to prioritize your mental health? What's something you can say \"yes\" to?",
  "What song makes you happy? Play it in the background while you answer the next few cards.",
  "What do you need right now more than anything?",
  "How do you define happiness? Get specific.",
  "What piece of advice has helped your mental health the most?",
  "What does prioritizing your\n mental health look like in this\n chapter of your life?\n Get specific.", //

  "Wild Card Illustrate how your mind feels today. 30 seconds.",
  "Wild Card Get something off your chest. Write it out. 1 minute. Don't overthink it.",
  "Wild Card Write out an intrusive thought. Cross it out. Replace it with a positive affirmation.",
  "Wild Card What would feel best to let go of today? Write it out and rip it up.",
  "Wild Card Write out 3 things that made you smile today.",
  "Wild Card Stretch for 30 seconds before flipping to the next card.",
  "Wild Card Jump up and down as if you're celebrating the best news of your life for 30 seconds before flipping to the next card. (No seriously, do it).",
  "Wild Card What promise do you want to keep to yourself this year? Write it out and date it.",
  "Wild Card Admit something (to yourself)",
  "Wild Card Take 3 deep breaths before flipping to the next card. Hold for 2 seconds between each breath.",
  "Wild Card Write down the names of everyone you feel unconditionally loved by. Make more time for these people (even if it's yourself).",
  "Wild Card Delete all of your social media apps for a day. Journal about how you felt after.",
  "Reminder Pay attention to\n who you're with\n when you feel\n your best.",
  "Reminder If you're trying\n not to think\n about it, it's\n probably time\n to heal it.",
  "Reminder You don't have\n to have it all\n figured out right\n now. Sleep on it.", //
  "Reminder I'm proud of the\n progress you're\n making. No matter\n how small.", //
]